import MojitoModules from 'mojito/modules';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

export function getMarketsConfig() {
    return {
        custom: {
            [PALETTE_IDS.MARKETS]: {
                AggregatedMarket: {
                    market: {
                        headerLabel: {
                            style: {
                                whiteSpace: 'normal',
                            },
                        },
                    },
                    layoutDescriptors: {
                        categories: {
                            DOUBLE_CHANCE: {
                                selectionsHeaderContent: undefined,
                            },
                        },
                    },
                },
                GameLineMarketContent: {
                    selectionNameDisplay: {
                        TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT,
                    },
                    market: {
                        selectionButton: {
                            view: {
                                padding: '2px',
                                infoTextContainer: {
                                    itemSpacing: '2px',
                                },
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.MARKETS]: {
                MARKETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                MARKETS_CONTAINER_HEADER_BG: COLOR.BRAND.BACKGROUND2,
                MARKETS_CONTAINER_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                MARKETS_CONTAINER_HEADER_BET_BUILDER_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MARKETS_CONTAINER_HEADER_CASHOUT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,

                MARKETS_TEAM_NAME_TEXT: COLOR.BRAND.FOREGROUND1,
                MARKETS_PRICE_BOOST_ITEM: {
                    PBI_SELECTION_NAME_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontWeight: FONT.WEIGHT_BOLD,
                    },
                    PBI_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                    PBI_PREVIOUS_PRICE_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontSize: FONT.SIZE_MEDIUM,
                    },
                },
                MARKETS_CORRECT_SCORE_NUMBER_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                MARKETS_HANDICAP_RANGE_INPUT: {
                    RANGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
                },
            },
            [PALETTE_IDS.EVENT_TIPS]: {
                EVENT_TIPS_CARD_TITLE_TEXT: COLOR.BRAND.FOREGROUND1,
            },
        },
    };
}
